<template>
    <transition name="fade" mode="out-in">
        <div class="fixed inset-0 bg-black/40 h-screen flex justify-center items-center z-50">
            <div class="w-[85%] lg:w-1/2 bg-white rounded-3xl shadow relative">
                <!-- Header -->
                <div
                    class="text-white w-full py-3 text-lg  bg-gradient-to-br from-gifty-pink to-gifty-pink_dark  rounded-t-3xl flex justify-center items-center text-center font-extrabold font-arabic">
                    {{ $t('register.location.modal_title') }}
                </div>
                <!-- description help  -->
                <div
                    class=" text-gray-800 text-base  font-arabic flex justify-center items-center text-center px-7 pt-5 pb-3 bg-white ">
                    {{ $t('register.location.instructions') }}
                </div>
                <!-- Body -->
                <div class="w-full px-3 py-5 grid grid-cols-1 gap-4 bg-slate-100 border-t border-gray-200 rounded-b-xl">
                    <div class="w-full relative">

                        <div id="map" class="w-full h-[350px] rounded-xl"></div>

                    </div>

                    <!-- Buttons -->
                    <div class="flex flex-col justify-center gap-1">


                        <button @click="submitLocation"
                            class="px-4 py-2 rounded-lg font-bold text-white  bg-gradient-to-br from-gifty-pink to-gifty-pink_dark  hover:bg-[#a32b45] font-arabic">
                            {{ $t('register.location.submit') }}
                        </button>

                        <button @click="emit('toggleOff')"
                            class="px-4 py-2 rounded-lg  text-gray-600 underline font-semibold font-arabic">
                            {{ $t('register.location.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
/* global google */
import { useRegistrationStore } from "@/stores/registrationStore";
import { ref, onMounted, defineEmits } from "vue";


const registerStore = useRegistrationStore();
const emit = defineEmits(["toggleOff"]);


const map = ref(null);
const marker = ref(null);
const lat = ref(registerStore.registration.geolocation?.latitude || 36.7627);
const lng = ref(registerStore.registration.geolocation?.longitude || 3.0574);
onMounted(async () => {
    await loadGoogleMaps();

    const mapOptions = {
        center: { lat: lat.value, lng: lng.value },
        zoom: 13,
    };

    map.value = new google.maps.Map(document.getElementById("map"), mapOptions);

    marker.value = new google.maps.Marker({
        position: mapOptions.center,
        map: map.value,
        draggable: true,
    });

    marker.value.addListener("dragend", (e) => {
        lat.value = e.latLng.lat();
        lng.value = e.latLng.lng();
    });

    map.value.addListener("click", (e) => {
        lat.value = e.latLng.lat();
        lng.value = e.latLng.lng();
        marker.value.setPosition({ lat: lat.value, lng: lng.value });
    });
});

const loadGoogleMaps = () => {
    return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
            resolve();
            return;
        }

        const GoogleMAPsKey = process.env.VUE_APP_GOOGLE_MAPS_KEY || 'notdef'
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GoogleMAPsKey}`;
        console.log('script.src :>> ', script.src);
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
};

const submitLocation = () => {

    registerStore.registration.geolocation = {
        longitude: lng.value,
        latitude: lat.value
    };

    emit("toggleOff");
};
</script>

<style scoped>
#google-map {
    width: 100%;
    height: 100%;
    border-radius: 0.75rem;
}
</style>